//
//
//
//
//
//
//
//
//
//
//
//
//
//
import trusted from '~/assets/img/footer/picto-trustedShops.png';
export default {
  name: 'TrustedShops',
  data: function data() {
    return {
      trusted: trusted
    };
  }
};